/** 市场营销平台 — 统一项目库 */

export type ProjectCategory = 'preliminary' | 'performance';

export interface MarketProject {
  /**
   * 内部唯一标识：优先取台账「项目编号」；台账未编号的项目由数据脚本生成
   * （对接记录、地图选中态等均以此字段关联）。
   */
  id: string;
  /** 台账「项目编号」原文，未编号的项目为空字符串，详情页显示为「—」 */
  code: string;
  name: string;
  category: ProjectCategory;
  isNonEnergyPower: boolean;
  industry: string;
  businessType: string;
  location: string;
  province: string;
  city: string;
  region: string;
  client: string;
  leader: string;
  owner: string;
  department: string;
  contractAmountWan: number | null;
  overview: string;
  latitude: number | null;
  longitude: number | null;
  isOverseas: boolean;
  country: string;
}

export type ProjectCategoryFilter = 'all' | ProjectCategory;

export interface ProjectsDataFilter {
  category: ProjectCategoryFilter;
  keyword?: string;
  industries?: string[];
  regions?: string[];
  businessTypes?: string[];
  departments?: string[];
}

export const DEFAULT_PROJECTS_DATA_FILTER: ProjectsDataFilter = {
  category: 'all',
};

export interface MarketProjectStatistics {
  preliminary: number;
  performance: number;
}

export interface MarketFilterOptions {
  industries: string[];
  regions: string[];
  businessTypes: string[];
  departments: string[];
}

/**
 * 侧栏多选字典，与在线「项目库台账」单选选项一致。
 * 展示顺序按字典，数据里多出的值追加在末尾。
 */
export const MARKET_INDUSTRY_CATALOG = [
  '房屋建筑',
  '城市轨道交通',
  '公路工程',
  '城市道路',
  '综合管廊',
  '管线工程',
  '园林绿化',
  '机场',
  '数字化',
] as const;

export const MARKET_REGION_CATALOG = [
  '北方区域',
  '华东区域',
  '华中区域',
  '南方区域',
  '西部区域',
  '国际',
] as const;

export const MARKET_BUSINESS_TYPE_CATALOG = [
  '工程总承包',
  '技术服务',
  '科技研发',
] as const;

export const MARKET_DEPARTMENT_CATALOG = [
  '经营计划所',
  '国际工程所',
  '道路桥梁所',
  '公路与市政所',
  '环境景观所',
  '工程设备所',
  '数字工程所',
  '工程管理所',
  '轨道交通所',
  '空间规划与方案创新中心',
] as const;
